import React from "react";

const NewChemicalAuthorization = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default NewChemicalAuthorization;